import { lazy } from 'react';

// project imports
import Loadable from '../components/Loadable'
import AuthLayout from '../layout/Auth';

// jwt auth
const LoginPage = Loadable(lazy(() => import('../pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('../pages/auth/Register')));
const PasswordRecoveryPage = Loadable(lazy(() => import('../pages/auth/PasswordRecoveryPage')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: <AuthLayout/>,
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: <LoginPage />
        },
        {
          path: '/register',
          element: <RegisterPage />
        },
        {
          path: '/recoveryPassword/',
          element: <PasswordRecoveryPage/>
        }
      ]
    }
  ]
};

export default LoginRoutes;
